exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "ul.title-tncs[data-v-6cb2de4c]{color:#212121;font-size:16px;font-weight:600}ul.item-tncs[data-v-6cb2de4c]{color:#777;font-size:15px;font-weight:400!important}", "", {"version":3,"sources":["/app/src/components/availability/result/inquiry/ResultRental.vue"],"names":[],"mappings":"AACA,+BACE,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,8BACE,WAAe,AACf,eAAgB,AAChB,yBAA4B,CAC7B","file":"ResultRental.vue","sourcesContent":["\nul.title-tncs[data-v-6cb2de4c] {\n  color: #212121;\n  font-size: 16px;\n  font-weight: 600;\n}\nul.item-tncs[data-v-6cb2de4c] {\n  color: #777777;\n  font-size: 15px;\n  font-weight: 400 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cb2de4c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/availability/result/inquiry/ResultRental.vue
// module id = 829
// module chunks = 13